export default __webpack_public_path__ + "static/media/btn-lanzamiento_letra.8949e865.png";